<div class="custom-toast-notificaiton-wrapper" [@animationOption2]="showToaster ? 'open': 'close'" *ngIf="!toasterOpts?.isEnhancedVersion">
  <div class="ui-g-12">
    <div class="ui-g-1 text-center">
      <i class="{{toasterOpts?.icon}} font-18"></i>
    </div>
    <div class="ui-g-10">
      <p class="font-12 mb-0">
        <span class="font-12">{{toasterOpts?.text}}</span>
      </p>
      <div class="d-flex">
        <span class="font-12 underline font-bold pointer mr-2" *ngIf="toasterOpts?.buttons?.undo"
          (click)="clickAction('undo')">Undo</span>
        <span class="font-12 underline font-bold pointer" *ngIf="toasterOpts?.buttons?.sendInvoice"
          (click)="clickAction('sendInvoice')">Send Invoice</span>
      </div>
    </div>
    <div class="ui-g-1 text-right">
      <i class="fal fa-times pointer" (click)="close()"></i>
    </div>
  </div>
</div>
<div class="custom-toast-notificaiton-wrapper-enhanced" [@animationOption2]="showToaster ? 'open': 'close'" *ngIf="toasterOpts?.isEnhancedVersion && toasterOpts?.data">
  <div class="flex-between-center w-100">
    <div class="flex-start-center gap-12px width-92p pointer pb-3" (click)="clickAction(toasterOpts?.actionKey || 'clickdAction')">
      <i class="{{toasterOpts?.icon}} font-18"></i>
      <span class="font-16 font-600">{{toasterOpts?.heading || ''}}</span>
    </div>
    <div class="font-20 font-400 pointer mb-3" (click)="close()">
      <i class="fal fa-times"></i>
    </div>
  </div>
  <div class="flex-row pointer" (click)="clickAction(toasterOpts?.actionKey || 'clickAction')">
    <span class="font-14 font-400">{{toasterOpts?.text}}</span>
  </div>
</div>
